const Callout = ({ children }: React.PropsWithChildren) => (
  <div className="text-can-midnight-steel flex flex-col items-start gap-4 rounded-2xl bg-[#EFF5F4] p-4 sm:flex-row sm:items-center">
    {children}
  </div>
);

export { Callout };
